import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-alert.tsx
var LazyAlert = lazy(() => import("./alert-ByICV8Mj.js").then((n) => n.n).then((module) => ({ default: module.Alert })));
function Alert({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "alert" }),
		children: /* @__PURE__ */ jsx(LazyAlert, { ...props })
	});
}
function AlertContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "alert" }),
		children: /* @__PURE__ */ jsx(LazyAlert, { ...props })
	});
}
var useAlertContent = () => {
	return useMemo(() => ({ alert: { component: AlertContent } }), []);
};
//#endregion
export { Alert, useAlertContent };
